/// <amd-module name="Build/Admin/Pool/Components/QueuedJobsSeries" />
import * as ChartSeries from "Analytics/Shared/ChartSeries/ChartSeries";
import * as ChartDataConverter from "Analytics/Shared/Common/Utils/ChartDataConverter";
import * as Colors from "Build/Admin/Pool/Colors";
import * as Resources from "Build/Admin/Pool/Resources";

export class QueuedJobsSeries extends ChartSeries.ChartSeries {
    public get name(): string {
        return Resources.QueuedJobs;
    }

    public get color(): string {
        return Colors.QueuedJobsColorPalette;
    }

    public get values(): number[] {
        return ChartDataConverter.formatData(this._data);
    }
}
